/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountInstallationMethod } from '../models/AccountInstallationMethod';

/**
* Details on the Eon permissions version and installation method. 
*/
export class AccountVersion {
  /**
  * Currently installed permissions version.
  */
  'installed': string;
  'installationMethod'?: AccountInstallationMethod;
  /**
  * Latest available permissions version.
  */
  'latest'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "installed",
      "baseName": "installed",
      "type": "string",
      "format": ""
    },
    {
      "name": "installationMethod",
      "baseName": "installationMethod",
      "type": "AccountInstallationMethod",
      "format": ""
    },
    {
      "name": "latest",
      "baseName": "latest",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AccountVersion.attributeTypeMap;
  }

  public constructor() {
  }
}



